import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface DataCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function DataCard({ title, subtitle, children, footer, className }: DataCardProps) {
  return (
    <div className={cn("card p-5 space-y-2", className)}>
      <header className="space-y-0.5">
        <h3 className="text-sm font-medium text-fg-secondary">{title}</h3>
        {subtitle && <p className="text-xs text-fg-muted">{subtitle}</p>}
      </header>
      <div>{children}</div>
      {footer && <footer className="pt-2 border-t border-border">{footer}</footer>}
    </div>
  );
}
